const ConduccoToDrive = () => {
  return (
    <svg width='168' height='40' viewBox='0 0 168 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M32.6847 39.3512C24.4937 40.1893 16.3026 40.2154 8.11154 39.4296C4.44377 39.0445 0.955471 35.5562 0.570399 31.8885C-0.215428 23.6974 -0.189292 15.5063 0.648807 7.31527C1.006 4.07787 4.07787 1.006 7.31526 0.648808C15.5063 -0.18929 23.6974 -0.215429 31.8885 0.570398C35.5562 0.95547 39.0445 4.44377 39.4296 8.11154C40.2154 16.3026 40.1893 24.4937 39.3512 32.6847C38.994 35.9221 35.9221 38.994 32.6847 39.3512Z'
        fill='#3024E1'
      />
      <path
        d='M28.9229 16.1806C27.4592 16.1806 26.1908 17.0048 25.5478 18.2123H14.027V16.1806H7.26123V23.8193H14.027V21.7877H25.5478C26.189 22.9952 27.4592 23.8193 28.9229 23.8193C31.0329 23.8193 32.7422 22.11 32.7422 20C32.7422 17.8899 31.0329 16.1806 28.9229 16.1806Z'
        fill='white'
      />
      <mask id='mask0_373_7161' maskUnits='userSpaceOnUse' x='64' y='0' width='40' height='40'>
        <rect x='64' width='40' height='40' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_373_7161)'>
        <path
          d='M71.7627 25.8846L76.3781 30.5C76.564 30.6859 76.6596 30.9076 76.665 31.1652C76.6703 31.4228 76.5801 31.6423 76.3944 31.8238C76.187 32.016 75.958 32.1121 75.7073 32.1121C75.4567 32.1121 75.2359 32.0138 75.0448 31.8172L69.0096 25.782C68.8814 25.6538 68.7895 25.5211 68.734 25.3838C68.6784 25.2466 68.6506 25.0965 68.6506 24.9335C68.6506 24.7812 68.6784 24.6356 68.734 24.4967C68.7895 24.3579 68.8814 24.2243 69.0096 24.0961L75.0448 18.0609C75.2307 17.875 75.4503 17.7794 75.7035 17.774C75.9567 17.7687 76.187 17.8643 76.3944 18.0609C76.5801 18.2468 76.6703 18.4663 76.665 18.7195C76.6596 18.9727 76.564 19.1976 76.3781 19.3942L71.7627 23.9936H83.8397C84.1083 23.9936 84.3331 24.0847 84.5139 24.2669C84.6947 24.4491 84.7851 24.6756 84.7851 24.9464C84.7851 25.2171 84.6947 25.4412 84.5139 25.6185C84.3331 25.7959 84.1083 25.8846 83.8397 25.8846H71.7627ZM96.2371 15.9904H84.1602C83.8915 15.9904 83.6668 15.8993 83.4859 15.717C83.3051 15.5348 83.2147 15.3083 83.2147 15.0376C83.2147 14.7668 83.3051 14.5428 83.4859 14.3654C83.6668 14.1881 83.8915 14.0994 84.1602 14.0994H96.2371L91.6217 9.48399C91.4358 9.2981 91.3402 9.07637 91.3348 8.81878C91.3295 8.56117 91.4197 8.34162 91.6054 8.16012C91.8129 7.96792 92.0419 7.87183 92.2925 7.87183C92.5431 7.87183 92.764 7.97012 92.955 8.1667L98.9903 14.202C99.1185 14.3301 99.213 14.4629 99.2739 14.6001C99.3348 14.7374 99.3653 14.8875 99.3653 15.0505C99.3653 15.2027 99.3348 15.3483 99.2739 15.4872C99.213 15.6261 99.1185 15.7596 98.9903 15.8878L92.955 21.9231C92.7691 22.109 92.5496 22.2046 92.2964 22.2099C92.0432 22.2153 91.8129 22.1197 91.6054 21.9231C91.4197 21.7372 91.3295 21.5176 91.3348 21.2645C91.3402 21.0112 91.4358 20.7863 91.6217 20.5898L96.2371 15.9904Z'
          fill='#1C1B1F'
        />
      </g>
      <g clipPath='url(#clip0_373_7161)'>
        <path
          d='M131.024 32.7606L132.788 35.8076C133.155 36.449 133.682 36.953 134.3 37.3196L140.6 26.4147H128C128 27.1249 128.183 27.8351 128.55 28.4765L131.024 32.7606Z'
          fill='#0066DA'
        />
        <path
          d='M148 13.5853L141.7 2.68042C141.081 3.04697 140.554 3.55098 140.188 4.19245L128.55 24.3528C128.19 24.9804 128 25.6912 128 26.4147H140.6L148 13.5853Z'
          fill='#00AC47'
        />
        <path
          d='M161.7 37.3196C162.319 36.953 162.845 36.449 163.212 35.8076L163.945 34.5475L167.45 28.4765C167.817 27.8351 168 27.1249 168 26.4147H155.399L158.08 31.6839L161.7 37.3196Z'
          fill='#EA4335'
        />
        <path
          d='M148 13.5853L154.3 2.68041C153.682 2.31386 152.971 2.13058 152.238 2.13058H143.762C143.029 2.13058 142.319 2.33677 141.7 2.68041L148 13.5853Z'
          fill='#00832D'
        />
        <path
          d='M155.4 26.4147H140.6L134.3 37.3196C134.919 37.6862 135.629 37.8694 136.362 37.8694H159.638C160.371 37.8694 161.081 37.6632 161.7 37.3196L155.4 26.4147Z'
          fill='#2684FC'
        />
        <path
          d='M161.631 14.2726L155.812 4.19245C155.446 3.55098 154.919 3.04697 154.3 2.68042L148 13.5853L155.4 26.4147H167.977C167.977 25.7045 167.794 24.9943 167.427 24.3528L161.631 14.2726Z'
          fill='#FFBA00'
        />
      </g>
      <defs>
        <clipPath id='clip0_373_7161'>
          <rect width='40' height='35.7388' fill='white' transform='translate(128 2.13058)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ConduccoToDrive
